import sdk from '@trazi/billing-processor/sdk/node';

const billingProcessorSDK = window => {
  return sdk(`${window.location.origin}/api`);
};

export default billingProcessorSDK;
